import React from "react";

import { akhilLogoSvg, helpIconSvg, phoneIconSvg } from "../assets/svg";
import { useSelector } from "react-redux";

function Topbar() {
    const isMobile = window.innerWidth <= 768;
    const { phone, logo } = useSelector((state) => state.dynamicStore);

    return (
        <div className="topbar-container">
            <div className="topbar-logo">
                {logo ? (
                    <> 
                        <img src={logo} height={"30px"} alt="akhil-logo" />
                    </>
                ) : (
                    <>
                        {akhilLogoSvg()}
                        <span className="topbar-logo-text f500-14px">
                            Akhil Systems
                        </span>
                    </>
                )}
            </div>

            <div className="topbar-right">
                <div className="topbar-right-contact">
                    <div className="topbar-right-contact-icon">
                        {phoneIconSvg({
                            bgColor: isMobile
                                ? "rgba(210, 212, 213, 1)"
                                : "#38414A",
                            color: isMobile
                                ? "#38414A"
                                : "rgba(210, 212, 213, 1)",
                        })}
                    </div>

                    {!isMobile && (
                        <div className="topbar-right-contact-texts-container">
                            <div className=" f500-16px topbar-right-contact-text">
                                {/* Sec-44 :{" "} */}
                                <span className="f500-14px">{phone}</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="topbar-right-help">{helpIconSvg()}</div>
            </div>
        </div>
    );
}

export default Topbar;
